import { render, staticRenderFns } from "./KSkeletonBox.vue?vue&type=template&id=4b3dd944&scoped=true&"
import script from "./KSkeletonBox.vue?vue&type=script&lang=js&"
export * from "./KSkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./KSkeletonBox.vue?vue&type=style&index=0&id=4b3dd944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3dd944",
  null
  
)

export default component.exports